import { connect } from '@vfde-sails/core';
import { mountOfferSummaryCard, updateOfferSummaryCard } from '../../components/offerSummaryCard';
import { State, mapStateToProps } from './selector';
import { getUpdateFlags } from './update';
import { AppId } from '../../enums/elementId';

function container(_: State) {
    const offerSummaryCard = mountOfferSummaryCard(AppId.OFFER_SUMMARY_CARD);
    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const { isLoggedIn, router, isContentEnabled } = newState;
            const update = getUpdateFlags(newState, oldState);

            if (router && update.offerSummaryCard) {
                updateOfferSummaryCard(
                    offerSummaryCard, router, isLoggedIn, isContentEnabled);
            }
        },
    };
}

export default connect(mapStateToProps)(container);
